export enum languageType {
  EN = 1,
  TH = 2,
}
